export default __webpack_public_path__ + "static/media/Scott-Jules.2371b461.png";